// src/modules/app-views/offers/pages/Init/components/tableColumns/validityColumn.js
// *******************************************************************************
// IMPORTS
// *******************************************************************************
import translateX from 'utils/translateX';
import { parseDateToDisplay } from 'utils/helpers';

// *******************************************************************************
// COLUMN FUNCTION
// *******************************************************************************
function validityColumn(buildColumnProps, options = {}) {
  const {
    key = 'validity',
    title = 'validity',
    dataIndex = ['validity', 'startDate'],
    width = 160,
    align = 'center',
    columnProps = { sort: true },
  } = options;

  return {
    key,
    title: translateX(title),
    dataIndex,
    width,
    align,
    ...buildColumnProps('validity.startDate', columnProps),
    render: (_, r) => {
      const startDate = r?.validity?.startDate;
      const endDate = r?.validity?.endDate;

      if (!startDate) return '—';

      const start = parseDateToDisplay({ date: startDate });
      if (!endDate) return start;

      const end = parseDateToDisplay({ date: endDate });
      return `${start} — ${end}`;
    },
  };
}

export default validityColumn;
